'use client'

import { useEffect } from 'react'

import { useFetch } from '@marketplace-web/shared/api-client'
import { getEprCountries } from 'data/api/get-epr-countries'
import { transformCountriesDto } from 'data/transformers/epr'

const useFetchEprCountries = () => {
  const {
    fetch: fetchEprCountries,
    isLoading,
    transformedData: countries,
    error,
  } = useFetch(getEprCountries, transformCountriesDto)

  useEffect(() => {
    fetchEprCountries()
  }, [fetchEprCountries])

  return {
    countries,
    isLoading,
    error,
  }
}

export default useFetchEprCountries
